import axios from "axios";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Select from "react-select";
import swal from "sweetalert";
import { BASE_URL } from "../Const/Url";
import Loader from "../CustomCommons/Loader";
import NextIcon from "../CustomCommons/NextIcon";
import Permission from "../CustomCommons/Permission";
import PreviousIcon from "../CustomCommons/PreviousIcon";
import {
  can_change_products,
  can_view_invoice,
  has_permissions,
} from "../CustomCommons/utils";
import ViewIcon from "../CustomCommons/ViewIcon";
import * as path from "../Routes/RoutePaths";
import { showToast } from "../../utils/ToastHelper";
import { logout_func2 } from "../Const/logoutCommon";
import { getExportFile } from "../../utils/HelperFunction";
import HelperExportComponent from "../../utils/HelperExportComponent";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const ProductReportFromDashboard = () => {
  const [isLoading, SetisLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPdId, setModalPdId] = useState(null);
  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const convertToApiDate = (selectedDate) =>
    selectedDate ? selectedDate.format("MM/DD/YYYY") : "";

  const getDatePickerValue = (dateValue) => {
    if (!dateValue) return null;
    const [monthValue, dayValue, yearValue] = dateValue.split("/");
    if (!monthValue || !dayValue || !yearValue) return null;

    return dayjs(`${yearValue}-${monthValue}-${dayValue}`);
  };
  const cRef = useRef();
  const [query, setQuery] = useState("");
  const [renking, setRenking] = useState("");
  const [total, setTotal] = useState(0);
  const [invDis, setInvDis] = useState(0);
  const [offDis, setOffdis] = useState(0);

  const [adminOrOutlet, setAdminOrOutlet] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [outletList, setOutletList] = useState([]);
  const [homeDecor, setHomedecor] = useState([]);
  const [Instyle, setInstyle] = useState([]);
  const [category, setCategory] = useState(null);

  // ofset code
  const [totalData, setTotalData] = useState(0);
  const [items_data, setItems_data] = useState([]);
  const [total_item, setTotal_item] = useState(0);
  const [isLoading2, SetisLoading2] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);

  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const limit = 10;
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const item_limit = pageNumber * limit;
  const this_page_items_show =
    item_limit > total_item ? total_item : item_limit;
  const page_show_start = item_limit - limit + 1;
  const pageCount = Math.ceil(total_item / limit);
  const indexOfLastPost = pageCount < pageNumber ? limit : pageNumber * limit;
  const offset = pageCount < pageNumber ? 0 : indexOfLastPost - limit;

  const [source, setSource] = useState("");
  
  const options3 = [
    { value: "", label: "Admin + Website + Outlet" },
    { value: 1, label: "Admin" },
    { value: 3, label: "Website" },
    { value: 2, label: "Outlet" },
    { value: 4, label: "Admin + Website" },
  ];

  const apiFunction = (url) => {
    axios
      .get(url)
      .then((res) => {
        setTotal_item(res.data?.data?.count);
        setTotalData(res.data?.data?.count);
        setItems_data(res.data?.data?.results);
        setNextUrl(res.data?.data?.next);
        setPrevUrl(res.data?.data?.previous);
        setTotal(res.data?.total);
        setInvDis(res.data?.invoices_discount);
        setOffdis(res.data?.offer_discount);

        // console.log(res.data);
        SetisLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
      });
  };
  const getOutlet = () => {
    const url = `${BASE_URL}api/v1/sales/admin/outlet/`;
    axios
      .get(url)
      .then((res) => {
        console.log(res.data.data.results);
        const result = res.data.data.results;
        const options = result.map((curr) => ({
          label: curr.name,
          value: curr.id,
        }));
        setOutletList(options);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
      });
  };
  const getCategory = (setState, id) => {
    const url = `${BASE_URL}api/v1/inventory/inventory/category/?category_type=2&limit=100&main_category=${id}`;

    axios
      .get(url)
      .then((res) => {
        // console.log(res.data.data.results);
        const result = res.data.data.results;
        const options = result.map((curr) => ({
          label: curr.name,
          value: curr.id,
        }));
        setState(options);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        // console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
      });
  };

  useEffect(() => {
    getOutlet();
    getCategory(setHomedecor, 0);
    getCategory(setInstyle, 1);
  }, []);
  const getSelectOutlet = (val, action) => {
    setSelectedOutlet(val.value);
  };

  useEffect(() => {
    apiFunction(
      `${BASE_URL}${"api/v1/inventory/inventory/invoice-product-report/"}?limit=${limit}&offset=${offset}&search=${query}`
    );
  }, []);

  const handlePaginationPrevious = () => {
    apiFunction(prevUrl);
    setPageNumber((prev) => {
      if (prev > 1) {
        return prev - 1;
      } else {
        return prev;
      }
    });
    // SetisLoading(false)
  };
  const handlePaginationNext = () => {
    // SetisLoading(true);
    apiFunction(nextUrl);
    setPageNumber((prev) => prev + 1);
    // SetisLoading(false)
  };
  const handleChangeCurrentPage = (val) => {
    setPageNumber(val);
  };

  useEffect(() => {
    if (pageCount !== 0) {
      if (pageCount < pageNumber) {
        setPageNumber(pageCount);
      }
    }
  }, [pageCount]);

  useEffect(() => {
    // Keep existing search optimization: call API when search is empty or meaningful.
    // This allows date/source clear actions to refresh data immediately.
    const isSearchQueryReady = query.length === 0 || query.length > 2;

    if (!isSearchQueryReady) return;

    apiFunction(
      `${BASE_URL}${"api/v1/inventory/inventory/invoice-product-report/"}?limit=${limit}&offset=${offset}&search=${query}${
        source ? `&ordering=${source}` : ""
      }${date1 && !date2 ? `&start=${date1}` : ""}${
        date1 && date2 ? `&start=${date1}&end=${date2}` : ""
      }${adminOrOutlet ? `&source=${adminOrOutlet}` : ""}${
        selectedOutlet && adminOrOutlet === 2 ? `&outlet=${selectedOutlet}` : ""
      }`
    );
  }, [
    pageNumber,
    query,
    source,
    date1,
    date2,
    renking,
    adminOrOutlet,
    selectedOutlet,
  ]);

  // ofset code

  const history = useHistory();
  // const [pageNumber, setPageNumber] = useState(updatedPageNumber);
  const usersPerPage = 15;
  const pagesVisited = pageNumber * usersPerPage;

  const [invoiceList, setInvoiceList] = useState([]);
  const date = new Date();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let currentDate = `${month}-${day}-${year}`;
  var options = {
    day: "numeric",
    year: "numeric",
    month: "numeric",
  };
  const HandlePrint = useReactToPrint({
    content: () => cRef.current,
    documentTitle: "Daily Sales Report",
    // onAfterPrint: () => swal("Printed"),
    bodyClass: "dis",
  });

  useEffect(() => {
    // getInvoiceList();
  }, []);
  useEffect(() => {
    // getInvoiceList();
    if (date1 === "undefined/undefined/" && date2 === "undefined/undefined/") {
      swal("Please select  dates");
    }
  }, []);

  const handleAdminOrOutlet = (newVal) => {
    // Keep empty source as empty string so selecting "Admin + Website + Outlet"
    // still updates state and triggers the report API refresh.
    const selectedSourceValue = newVal?.value;
    const normalizedSourceValue =
      selectedSourceValue === "" ? "" : Number(selectedSourceValue);

    setSelectedOutlet(null);
    setPageNumber(1);
    setAdminOrOutlet(normalizedSourceValue);
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="mx-3 my-3">
        <div className="cotagorey-head mb-4">
          <div>
            <h3> Product Report </h3>
            <input
              style={{ color: "black" }}
              type="text"
              className="filter-input"
              placeholder="Search here"
              onChange={(e) => {
                setQuery(e.target.value.toLocaleLowerCase());
              }}
            />
          </div>
          <div className="filter_div me-3">
            <div className="d-flex align-items-center">
              <div className="me-2 mb-3 mb-md-0">
                <p className="">Source :</p>
                <div
                  className="sl"
                  style={{ width: "180px", marginTop: "-15px" }}
                >
                  <Select
                    onChange={handleAdminOrOutlet}
                    defaultValue={
                      adminOrOutlet === 2
                        ? [{ value: 2, label: "Outlet" }]
                        : adminOrOutlet === 1
                        ? [{ value: 1, label: "Admin" }]
                        : adminOrOutlet === 3
                        ? [{ value: 3, label: "Website" }]
                        : adminOrOutlet === 4
                        ? [{ value: 4, label: "Admin + Website" }]
                        : [{ value: "", label: "Admin + Website + Outlet" }]
                    }
                    value={
                      adminOrOutlet === 2
                        ? [{ value: 2, label: "Outlet" }]
                        : adminOrOutlet === 1
                        ? [{ value: 1, label: "Admin" }]
                        : adminOrOutlet === 3
                        ? [{ value: 3, label: "Website" }]
                        : adminOrOutlet === 4
                        ? [{ value: 4, label: "Admin + Website" }]
                        : [{ value: "", label: "Admin + Website + Outlet" }]
                    }
                    options={options3}
                    placeholder="---Select---"
                  />
                </div>
              </div>
              {adminOrOutlet === 2 && (
                <div className="me-2 mb-3 mb-md-0">
                  <p className="">Outlets :</p>
                  <div
                    className="sl"
                    style={{ width: "180px", marginTop: "-15px" }}
                  >
                    <Select
                      onChange={getSelectOutlet}
                      options={outletList}
                      placeholder="---Select---"
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="mt-3">
              <DatePicker
                format="DD-MM-YYYY"
                allowClear={true}
                value={getDatePickerValue(date1)}
                className="date-input"
                onChange={(selectedDate) => {
                  setDate1(convertToApiDate(selectedDate));
                }}
              />
              <span className="mx-2 my-auto" placeholder="09-09-2022">
                {" "}
                To
              </span>
              <DatePicker
                format="DD-MM-YYYY"
                allowClear={true}
                value={getDatePickerValue(date2)}
                className="date-input"
                onChange={(selectedDate) => {
                  setDate2(convertToApiDate(selectedDate));
                }}
              />
            </div>
            <div
              className="button-div ms-2 my-auto me-2  text-white "
              style={{ background: "black", cursor: "pointer" }}
            >
              {/* {items_data?.length !== 0 ? (
                <>
                  <span
                    onClick={() =>
                      getExportFile(
                        `${BASE_URL}${"api/v1/inventory/inventory/top-product-report/"}?export=true&search=${query}${
                          date1 && !date2 ? `&start=${date1}` : ""
                        }${
                          date1 && date2 ? `&start=${date1}&end=${date2}` : ""
                        }${adminOrOutlet ? `&source=${adminOrOutlet}` : ""}${
                          selectedOutlet && adminOrOutlet === 2
                            ? `&outlet=${selectedOutlet}`
                            : ""
                        }`,
                        "product_report_export_file.xlsx"
                      )
                    }
                  >
                    {" "}
                    Export
                  </span>
                </>
              ) : (
                <>
                  <span
                    onClick={() =>
                      swal({
                        title: "Error!",
                        text: "There Is No Data",
                      })
                    }
                  >
                    {" "}
                    Export
                  </span>
                </>
              )} */}
              <HelperExportComponent
                url={`${BASE_URL}${"api/v1/inventory/inventory/invoice-product-report/"}?export=true&search=${query}${
                  date1 && !date2 ? `&start=${date1}` : ""
                }${date1 && date2 ? `&start=${date1}&end=${date2}` : ""}${
                  adminOrOutlet ? `&source=${adminOrOutlet}` : ""
                }${
                  selectedOutlet && adminOrOutlet === 2
                    ? `&outlet=${selectedOutlet}`
                    : ""
                }`}
                fileName={"product_report_export_file.xlsx"}
                items_data={items_data}
              />
            </div>
          </div>
        </div>
        <div className="d-flex gap-2">
        <div>
          <h6>Total : {total ? total : 0}</h6>
        </div>
        <div>
          <h6>Invoice Discount : {invDis ? invDis : 0}</h6>
        </div>
        <div>
          <h6>Offer Discount : {offDis ? offDis : 0}</h6>
        </div>
        
        </div>
        
        <div className="my-2">
          <p style={{ color: "red" }}>
            NOTE : The total amount may not reflect the actual sales data, as
            discounts and delivery charges are not included in this product
            report. Please refer to the sales report to view the actual data.
          </p>
          <p style={{ color: "red" }}>
           Note: This report will display accurate and complete data starting from December 24, 2024.
          </p>
        </div>
        {/* categorey list table */}
        <div style={{ display: "block", overflowX: "auto" }}>
          <table className="table_my">
            <thead
              className="bg-dark text-white head-row"
              style={{ height: "50px", borderTopLeftRadius: "20px !important" }}
            >
              <tr className="">
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                    textAlign: "start",
                    paddingLeft: "10px",
                  }}
                >
                  #ID
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "187px",
                  }}
                >
                  Date
                </th>

                {/* <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "187px",
                  }}
                >
                  Thumbnail
                </th> */}
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "187px",
                  }}
                >
                  Name
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "187px",
                  }}
                >
                  SKU
                </th>

                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Offer Discount
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Invoice Discount
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "70px",
                  }}
                >
                  Quantity
                </th>
                {/* <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Stock
                </th> */}
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Total Price
                </th>
              </tr>
            </thead>
            <tbody className="tb">
              {items_data.length > 0 && items_data ? (
                items_data.map((category, index) => (
                  <tr className="table-row " key={index}>
                    <td>
                      <p className="ms-3 my-auto">{index + 1}</p>
                    </td>
                    <td>{category?.invoice_date}</td>

                    {/* <td>
                      {" "}
                      <img
                        width={50}
                        style={{ margin: "6px 0px !important" }}
                        height={50}
                        src={category.thumb_url}
                        alt=""
                      />
                    </td> */}
                    <td>{category.name}</td>
                    <td>{category.sku}</td>
                    <td>{category?.given_discount}</td>
                    <td>{category?.given_invoice_discount}</td>
                    <td>{category?.quantity}</td>
                    {/* <td>{category?.stock}</td> */}
                    <td>{category?.total ? category?.total : 0}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colspan="9">
                    <div className="not_found d-flex justify-content-center align-items-center py-4">
                      <h4 className="my-4">No Data Found</h4>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* entites and paggination */}
        {totalData > 0 && (
          <div className="row pag" style={{ marginTop: "30px" }}>
            <div className="col-6 col-md-5">
              <p
                className="inter"
                style={{ color: "#AEAEB2", fontSize: "16px" }}
              >
                Total Entries:{" "}
                <span style={{ color: "black", fontSize: "14px" }}>
                  {totalData}
                </span>
                <span className="ms-2"></span>
                Total Page:{" "}
                <span style={{ color: "black", fontSize: "14px" }}>
                  {Math.ceil(totalData / 10)}
                </span>
              </p>
            </div>
            {/* <div className="col-12 col-md-6 d-flex paggination-button">
            <ReactPaginate
              previousLabel={<PreviousIcon />}
              nextLabel={<NextIcon />}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"a"}
              nextLinkClassName={"a"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
              initialPage={query?.length > 0 ? 0 : updatedPageNumber}
              forcePage={
                query?.length > 0 || getData?.length < usersPerPage
                  ? 0
                  : updatedPageNumber
              }
            />
          </div> */}
            <div className="col-12 col-md-6 d-flex paggination-button">
              <>
                <div className="row lead_pagination bg-transparent">
                  <div className="col-12 col-lg-6 d-flex justify-content-lg-end justify-content-md-end  col-md-6 col-sm-6  col-xs-12 pagination_container">
                    <nav aria-label="...">
                      <ul className="pagination pagination-sm">
                        {!isLoading ? (
                          <li className="page-item ">
                            {prevUrl !== null ? (
                              <Link
                                onClick={handlePaginationPrevious}
                                className={` ${
                                  prevUrl === null ? "disabled" : ""
                                } page-link pagination_texts  pagination_btn font_size_for_small py-1 mt-1 me-3 a`}
                                to="#"
                                tabindex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  showToast("success", "You are on first page")
                                }
                                className={` ${
                                  prevUrl === null ? "disabled" : ""
                                } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                to="#"
                                tabindex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            )}
                          </li>
                        ) : (
                          <li className="page-item ">
                            <Link
                              className={` ${
                                prevUrl === null ? "disabled" : ""
                              } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                              to="#"
                              tabindex="-1"
                            >
                              <PreviousIcon />
                            </Link>
                          </li>
                        )}

                        {[...Array(pageCount === null ? 1 : pageCount)].map(
                          (elem, index) => (
                            <li
                              className="page-item"
                              style={{
                                display: `${
                                  index + 1 !== pageNumber ? "none" : "block"
                                }`,
                              }}
                            >
                              {/*  style={{
                    display: `${index + 1 !== pageNumber ? "none" : "block"}`,
                  }} */}
                              {/* setPageNumber(prev=> prev - 1) */}

                              <Link
                                onClick={() =>
                                  handleChangeCurrentPage(index + 1)
                                }
                                className={`${
                                  index + 1 == pageNumber
                                    ? "paginationActive"
                                    : ""
                                } page-link lead_page_link lead_page_link1 font_size_for_small pagination_texts px-2 text-dark`}
                                to="#"
                              >
                                <span className="px-1 py-1">{pageNumber}</span>
                              </Link>
                            </li>
                          )
                        )}
                        {!isLoading ? (
                          <li className="page-item">
                            {nextUrl !== null ? (
                              <Link
                                onClick={handlePaginationNext}
                                className={`${
                                  nextUrl === null ? "disabled" : ""
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />{" "}
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  showToast("success", "You are on last page")
                                }
                                className={`${
                                  nextUrl === null ? "disabled" : ""
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />
                              </Link>
                            )}
                          </li>
                        ) : (
                          <li className="page-item">
                            <Link
                              className={`${
                                nextUrl === null ? "disabled" : ""
                              } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                              to="#"
                            >
                              <NextIcon />
                            </Link>
                          </li>
                        )}
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductReportFromDashboard;
